import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, inView = true, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block will-change-transform ${innerClassName}`}
      initial={{ y: "112%" }}
      {...(inView
        ? { whileInView: { y: 0 }, viewport: { once: true, amount: 0.4 } }
        : { animate: { y: 0 } })}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, inView = true, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 16 }}
    {...(inView
      ? { whileInView: { opacity: 1, y: 0 }, viewport: { once: true, amount: 0.3 } }
      : { animate: { opacity: 1, y: 0 } })}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
